module.exports = __webpack_public_path__ + "img/MT.791bdef4.svg";